export const companyEn = {};

export const companyFr = {};
